import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import AboutPage from './components/AboutPage';
import AdminLayout from './components/AdminLayout';
import ForgotPassword from './components/auth/ForgotPassword';
import LoginPage from './components/auth/LoginPage';
import ResetPassword from './components/auth/ResetPassword';
// import ContactPage from './components/ContactPage';
import LandingPage from './components/LandingPage';
import AdManager from './components/pages/AdManager';
import Dashboard from './components/pages/Dashboard';
// import EventsManager from './components/pages/EventsManager';
import FeaturedShowsManager from './components/pages/FeaturedShowsManager';
// import FoundationManager from './components/pages/FoundationManager';
// import FuneralManager from './components/pages/FuneralManager';
// import NewsManager from './components/pages/NewsManager';
import NotificationCenter from './components/pages/NotificationCenter';
// import PlaybackHistory from './components/pages/PlaybackHistory';
import ProfilePage from './components/pages/ProfilePage';
import ScheduleManager from './components/schedule/ScheduleManager';
import SettingsManager from './components/pages/SettingsManager';
// import TeamManager from './components/pages/TeamManager';
import UpcomingSchedule from './components/pages/UpcomingSchedule';
import PrivacyPolicy from './components/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
import CategoriesManager from './components/categories/CategoriesManager';
import ShowsManager from './components/shows/ShowsManager';
import NewsLetter from './components/newsletter/NewsLetter';

// function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// }

export default function App() {
  return (
    <BrowserRouter >
      {/* <ScrollToTop /> */}
      <div className="font-outfit text-slate-50 text-sm">
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');
          body, main, button, input, textarea, select { font-family: 'Outfit', sans-serif; }
          /* ... (other styles remain the same) */
        `}</style>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* <Route path="/contact" element={<ContactPage />} /> */}

          {/* Protected Admin Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path='/admin' element={<AdminLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="categories" element={<CategoriesManager />} />
              <Route path="shows" element={<ShowsManager />} />
              <Route path="schedule" element={<ScheduleManager />} />
              <Route path="featured-shows" element={<FeaturedShowsManager />} />
              <Route path="notifications" element={<NotificationCenter />} />
              <Route path="ads" element={<AdManager />} />
              <Route path="settings" element={<SettingsManager />} />
              <Route path="upcoming-schedule" element={<UpcomingSchedule />} />
              <Route path="newsletters" element={<NewsLetter />} />
              {/* <Route path="news" element={<NewsManager />} /> */}
              {/* <Route path="events" element={<EventsManager />} /> */}
              {/* <Route path="funerals" element={<FuneralManager />} /> */}
              {/* <Route path="foundation" element={<FoundationManager />} /> */}
              {/* <Route path="team" element={<TeamManager />} /> */}
              {/* <Route path="playback-history" element={<PlaybackHistory />} /> */}
              {/* <Route index element={<Navigate to="dashboard" replace />} /> */}
            </Route>
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter >
  );
}